export default {
  namespaced: true,
  state: {
    selectedType: ''
  },
  mutations: {
    setSelectedType (state, type) {
      state.selectedType = type
    }
  }
}
